import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-admin-set-post-tracking-payment',
  templateUrl: './admin-set-post-tracking-payment.component.html',
  styleUrls: ['./admin-set-post-tracking-payment.component.sass'],
})
export class AdminSetPostTrackingPaymentComponent implements OnInit {
  public inputControl = new FormControl('', [
    Validators.required,
    Validators.maxLength(24),
    Validators.minLength(24),
  ]);

  constructor(
    private dialogRef: MatDialogRef<AdminSetPostTrackingPaymentComponent>
  ) {}
  ngOnInit(): void {}

  saveCode(code: string) {
    this.dialogRef.close(code);
  }
}
